import { BrowserRouter, Routes, Route } from "react-router";
import Landing from "./pages/Landing";
import LandingXero from "./pages/LandingXero";
import LandingOwn from "./pages/LandingOwn";
import TermsAndConditions from "./pages/TermsAndConditions";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import AdditionalTermsForPartners from "./pages/AdditionalTermsForPartners";
import Layout from "./components/layout/Layout";
import ScrollToTop from "./components/layout/ScrollToTop";

function App() {
    return (
        <BrowserRouter>
            <ScrollToTop />
            <Layout>
                <Routes>
                    <Route index element={<Landing />} />
                    <Route path="in" element={<LandingOwn />} />
                    <Route path="out" element={<LandingXero />} />
                    <Route path="terms-and-conditions" element={<TermsAndConditions />} />
                    <Route path="privacy-policy" element={<PrivacyPolicy />} />
                    <Route path="additional-terms" element={<AdditionalTermsForPartners />} />
                </Routes>
            </Layout>
        </BrowserRouter>
    );
}

export default App;
